export default __webpack_public_path__ + "static/reference_image-e4077fc1bc097f5c9a4eca51a521676b.jpg";